import { createFileRoute } from '@tanstack/react-router';

import { DisplayNameStep } from '@/features/onboarding/components/steps/personal/displayNameStep';
import { getMyUserOptions } from '@/features/users/hooks/useGetMyUser/getMyUser.options';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/display-name',
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(getMyUserOptions());
  },
});

function RouteComponent() {
  return <DisplayNameStep />;
}
